import { Suspense } from 'react';
import { lazily } from 'react-lazily';

import { Loader } from '@kit/loaders/loader';

import { LoadableType } from './types';

export const appLazily = lazily;

export const Loadable: LoadableType = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
